import React from "react";

function About() {
  return (
    <div>
      <section className="w-100 float-left Solution-con bg-dark-black glow-img position-relative">
        <div className="wrapper2">
          <div className="generic-title text-center">
            <h2 className="mb-3">What is DNET?</h2>
            <p className="p-new">
              DNET is an innovative decentralized finance (DeFi) ecosystem{" "}
              <br />
              leveraging the power of Arbitrum blockchain to provide users with
              a secure, scalable, <br /> and transparent financial model.
            </p>
          </div>
          <h3>Key Highlights</h3>
          <div className="wrapper2">
            <div className="blog-post2-box">
              <div
                className="blog-post2-item aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={600}
              >
                <div className="blog-post-content-box">
                  <figure className="mb-0">
                    <img
                      src="../assets/images/img/built_on_arbitrum.jpg"
                      alt="home-blog-post-img"
                    />
                  </figure>
                  <div className="blog-post2-content text-white">
                    <h5>Built on Arbitrum</h5>
                    <p className="mb-0">
                      <a>Fast, low-cost, and scalable blockchain network.</a>
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="blog-post2-item aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={600}
              >
                <div className="blog-post-content-box">
                  <figure className="mb-0">
                    <img
                      src="../assets/images/img/yield_optimization_image.jpg"
                      alt="home-blog-post-img"
                    />
                  </figure>
                  <div className="blog-post2-content text-white">
                    <h5>Yield Optimization</h5>
                    <p className="mb-0">
                      <a>AI-enhanced strategies for maximizing returns.</a>
                    </p>
                  </div>
                </div>
                <div className="blog-post-content-box">
                  <figure className="mb-0">
                    <img
                      src="../assets/images/img/secure_and_transparent.jpg"
                      alt="home-blog-post-img"
                    />
                  </figure>
                  <div className="blog-post2-content text-white">
                    <h5>Secure & Transparent</h5>
                    <p className="mb-0">
                      <a> Blockchain-backed, trustless transactions.</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
